import PlansPage from '@/views/profile/PlansPage'

export default function PlansScreen() {
  return <PlansPage />
}
